class BrandsHorizontalScroll {
  constructor() {
    this.brandsContainers = document.querySelectorAll('.brands__items');
    this.init();
  }

  init() {
    this.brandsContainers.forEach((container, index) => {
      this.setupTouchSwipe(container);
      
      if (this.hasScrollableContent(container)) {
        this.setupMouseWheelScroll(container);
        this.setupScrollIndicators(container);
      } else {
        setTimeout(() => {
          if (this.hasScrollableContent(container)) {
            this.setupMouseWheelScroll(container);
            this.setupScrollIndicators(container);
          }
        }, 500);
      }
    });
  }

  hasScrollableContent(container) {
    container.offsetWidth;
    
    const isScrollable = container.scrollWidth > container.clientWidth;
    
    if (!isScrollable) {
      const images = container.querySelectorAll('img');
      if (images.length > 0) {
        let loadedImages = 0;
        const totalImages = images.length;
        
        images.forEach(img => {
          if (img.complete) {
            loadedImages++;
          } else {
            img.addEventListener('load', () => {
              loadedImages++;
              if (loadedImages === totalImages) {
                setTimeout(() => {
                  this.recheckScrollability(container);
                }, 100);
              }
            });
          }
        });
      }
    }
    
    return isScrollable;
  }

  recheckScrollability(container) {
    if (this.hasScrollableContent(container)) {
      this.setupMouseWheelScroll(container);
      this.setupScrollIndicators(container);
    }
  }

  setupScrollIndicators(container) {
    const brandsSection = container.closest('.brands');
    if (!brandsSection) return;

    const updateIndicators = () => {
      const isAtStart = container.scrollLeft <= 5;
      const isAtEnd = container.scrollLeft >= (container.scrollWidth - container.clientWidth - 5);
      
      if (isAtStart) {
        brandsSection.style.setProperty('--fade-left-opacity', '0');
      } else {
        brandsSection.style.setProperty('--fade-left-opacity', '1');
      }
      
      if (isAtEnd) {
        brandsSection.style.setProperty('--fade-right-opacity', '0');
      } else {
        brandsSection.style.setProperty('--fade-right-opacity', '1');
      }
    };

    updateIndicators();
    
    container.addEventListener('scroll', updateIndicators);
    
    window.addEventListener('resize', updateIndicators);
  }

  setupMouseWheelScroll(container) {
    let velocity = 0;
    let animationId = null;
    let lastWheelTime = 0;
    let wheelEventCount = 0;
    let momentumTimeout = null;
    
    const momentumScroll = () => {
      if (Math.abs(velocity) > 0.5) {
        container.scrollLeft += velocity;
        velocity *= 0.95;
        animationId = requestAnimationFrame(momentumScroll);
      } else {
        velocity = 0;
        animationId = null;
      }
    };

    container.addEventListener('wheel', (e) => {
      const hasScrollableContent = container.scrollWidth > container.clientWidth;
      
      if (!hasScrollableContent) {
        return;
      }

      const atLeftEdge = container.scrollLeft <= 0 && e.deltaY < 0;
      const atRightEdge = container.scrollLeft >= (container.scrollWidth - container.clientWidth) && e.deltaY > 0;
      
      if (!atLeftEdge && !atRightEdge) {
        e.preventDefault();
        
        if (animationId) {
          cancelAnimationFrame(animationId);
          animationId = null;
        }
        if (momentumTimeout) {
          clearTimeout(momentumTimeout);
          momentumTimeout = null;
        }
        
        container.scrollLeft += e.deltaY;
        
        wheelEventCount++;
        lastWheelTime = Date.now();
        
        if (wheelEventCount > 2) {
          velocity += e.deltaY * 0.2;
          velocity = Math.max(-12, Math.min(12, velocity));
        }
        
        setTimeout(() => {
          if (Date.now() - lastWheelTime >= 100) {
            wheelEventCount = 0;
          }
        }, 100);
        
        momentumTimeout = setTimeout(() => {
          if (Date.now() - lastWheelTime >= 100 && wheelEventCount > 2 && !animationId) {
            momentumScroll();
          }
          wheelEventCount = 0;
        }, 100);
      }
    }, { passive: false });
  }

  setupTouchSwipe(container) {
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let isDragging = false;
    let startScrollLeft = 0;

    container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startScrollLeft = container.scrollLeft;
      isDragging = true;
      
      container.style.scrollBehavior = 'auto';
    }, { passive: true });

    container.addEventListener('touchmove', (e) => {
      if (!isDragging) return;

      currentX = e.touches[0].clientX;
      currentY = e.touches[0].clientY;
      
      const deltaX = startX - currentX;
      const deltaY = startY - currentY;
      
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        e.preventDefault();
        
        const newScrollLeft = startScrollLeft + deltaX;
        container.scrollLeft = newScrollLeft;
      }
    }, { passive: false });

    container.addEventListener('touchend', () => {
      isDragging = false;
      
      container.style.scrollBehavior = 'smooth';
    }, { passive: true });

    container.addEventListener('touchcancel', () => {
      isDragging = false;
      container.style.scrollBehavior = 'smooth';
    }, { passive: true });
  }

  smoothScroll(container, amount, callback) {
    const currentScroll = container.scrollLeft;
    const targetScrollLeft = currentScroll + amount;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    const clampedTarget = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
    
    container.scrollTo({
      left: clampedTarget,
      behavior: 'smooth'
    });
    
    setTimeout(callback, 300);
  }

  handleScrollEnd(container) {
    let scrollTimeout;
    
    container.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        this.snapToNearestItem(container);
      }, 150);
    });
  }

  snapToNearestItem(container) {
    const items = container.querySelectorAll('.brands__item');
    if (items.length === 0) return;

    const containerRect = container.getBoundingClientRect();
    const containerCenter = containerRect.left + containerRect.width / 2;
    
    let closestItem = null;
    let closestDistance = Infinity;

    items.forEach(item => {
      const itemRect = item.getBoundingClientRect();
      const itemCenter = itemRect.left + itemRect.width / 2;
      const distance = Math.abs(containerCenter - itemCenter);
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });

    if (closestItem) {
      const itemRect = closestItem.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const scrollAmount = itemRect.left - containerRect.left;
      
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  }
}

function initializeBrandsScroll() {
  setTimeout(() => {
    new BrandsHorizontalScroll();
  }, 100);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBrandsScroll);
} else {
  initializeBrandsScroll();
}

document.addEventListener('shopify:section:load', () => {
  setTimeout(() => {
    new BrandsHorizontalScroll();
  }, 100);
});
